<h2 mat-dialog-title>{{ action === 'edit' ? 'Edit' : 'Create' }} Notification Template</h2>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form" class="d-flex flex-column gap-2">
        <div class="row">
            <div class="col-4">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Approach</mat-label>
                    <input matInput formControlName="approach" placeholder="e.g., _default, LEA Renewal">
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Event Name</mat-label>
                    <input matInput formControlName="eventName" placeholder="e.g., APPLICATION_STARTED">
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName="role">
                        <mat-option value="APPLICANT">APPLICANT</mat-option>
                        <mat-option value="ORIGINATOR">ORIGINATOR</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="subject">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title">
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-100">
            <mat-label>Body</mat-label>
            <textarea matInput formControlName="body" rows="8"></textarea>
        </mat-form-field>
        <div class="d-flex gap-3">
            <mat-checkbox formControlName="enabled">Enabled</mat-checkbox>
            <mat-checkbox formControlName="emailEnabled">Email Enabled</mat-checkbox>
            <mat-checkbox formControlName="inboxEnabled">Inbox Enabled</mat-checkbox>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="!form.valid || submitting">
        {{ submitting ? 'Submitting...' : 'Submit' }}
    </button>
</mat-dialog-actions>
